import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LineSegments } from '../objects/LineSegments.js';
import { Matrix4 } from '../math/Matrix4.js';
import { LineBasicMaterial } from '../materials/LineBasicMaterial.js';
import { Color } from '../math/Color.js';
import { Vector3 } from '../math/Vector3.js';
import { BufferGeometry } from '../core/BufferGeometry.js';
import { Float32BufferAttribute } from '../core/BufferAttribute.js';

var _vector = /*@__PURE__*/new Vector3();

var _boneMatrix = /*@__PURE__*/new Matrix4();

var _matrixWorldInv = /*@__PURE__*/new Matrix4();

var SkeletonHelper = /*#__PURE__*/function (_LineSegments) {
  _inherits(SkeletonHelper, _LineSegments);

  var _super = _createSuper(SkeletonHelper);

  function SkeletonHelper(object) {
    var _this;

    _classCallCheck(this, SkeletonHelper);

    var bones = getBoneList(object);
    var geometry = new BufferGeometry();
    var vertices = [];
    var colors = [];
    var color1 = new Color(0, 0, 1);
    var color2 = new Color(0, 1, 0);

    for (var i = 0; i < bones.length; i++) {
      var bone = bones[i];

      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors.push(color1.r, color1.g, color1.b);
        colors.push(color2.r, color2.g, color2.b);
      }
    }

    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
    var material = new LineBasicMaterial({
      vertexColors: true,
      depthTest: false,
      depthWrite: false,
      toneMapped: false,
      transparent: true
    });
    _this = _super.call(this, geometry, material);
    _this.type = 'SkeletonHelper';
    _this.isSkeletonHelper = true;
    _this.root = object;
    _this.bones = bones;
    _this.matrix = object.matrixWorld;
    _this.matrixAutoUpdate = false;
    return _this;
  }

  _createClass(SkeletonHelper, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      var bones = this.bones;
      var geometry = this.geometry;
      var position = geometry.getAttribute('position');

      _matrixWorldInv.copy(this.root.matrixWorld).invert();

      for (var i = 0, j = 0; i < bones.length; i++) {
        var bone = bones[i];

        if (bone.parent && bone.parent.isBone) {
          _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);

          _vector.setFromMatrixPosition(_boneMatrix);

          position.setXYZ(j, _vector.x, _vector.y, _vector.z);

          _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);

          _vector.setFromMatrixPosition(_boneMatrix);

          position.setXYZ(j + 1, _vector.x, _vector.y, _vector.z);
          j += 2;
        }
      }

      geometry.getAttribute('position').needsUpdate = true;

      _get(_getPrototypeOf(SkeletonHelper.prototype), "updateMatrixWorld", this).call(this, force);
    }
  }]);

  return SkeletonHelper;
}(LineSegments);

function getBoneList(object) {
  var boneList = [];

  if (object && object.isBone) {
    boneList.push(object);
  }

  for (var i = 0; i < object.children.length; i++) {
    boneList.push.apply(boneList, getBoneList(object.children[i]));
  }

  return boneList;
}

export { SkeletonHelper };